import React, { useState, useEffect } from 'react';
import { useSnackbarContext } from '../contexts/Snackbar';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../hooks/useQuery';
import {
  updateWiseConnection,
  getWiseAccounts,
  addBankAccount,
} from '../components/API';
import { pathname, RedirectToConnectAccountsKey } from '../utils';
import messages from '../messages';
import LoadingBackdrop from '../components/LoadingBackdrop';

const allowedRedirects = [
  pathname.connectAccounts.url,
  pathname.account.main.url,
];

export default function WiseRedirect() {
  const query = useQuery();
  const snackbar = useSnackbarContext();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  function consentDenied(reference: string, error: string) {
    setLoading(true);
    updateWiseConnection({ id: reference, error }).catch((error) => null);
    setLoading(false);
  }

  async function consentAccepted(reference: string) {
    try {
      setLoading(true);
      const accounts = await getWiseAccounts(reference);
      if (accounts.length === 0) {
        throw Error('No Account Information Returned');
      }
      await Promise.all(
        accounts.map((account) =>
          addBankAccount({
            bank: 'Wise',
            accountId: account.id,
            accountNumber:
              account.accountNumber || account.bban || account.iban,
            routingNumber: '084009519',
            account: account.name,
            accountType: account.product,
            currency: account.currency,
            owners: account.ownerName,
            tokenId: reference,
          }),
        ),
      );
      snackbar.show(messages.wiseRedirect.success, 'success');
    } catch (error) {
      snackbar.show(messages.wiseRedirect.errors.update, 'error');
    }
    setLoading(false);
  }

  async function handleWiseRedirect() {
    const reference = query.get('ref');
    const error = query.get('error');
    if (reference && error) {
      consentDenied(reference, error);
    }
    if (reference && !error) {
      await consentAccepted(reference);
    }
    const redirectPath = localStorage.getItem(RedirectToConnectAccountsKey);
    localStorage.removeItem(RedirectToConnectAccountsKey);
    if (allowedRedirects.includes(redirectPath)) {
      history.push(redirectPath + '?expand=bank');
    } else {
      history.push(pathname.account.main.url + '?expand=bank');
    }
  }

  useEffect(() => {
    handleWiseRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <LoadingBackdrop open={loading} />
    </div>
  );
}
